const iniciarCotizador = () => {
    const paqueteSelect = document.querySelector('#paquete_id');
    const modalidadSelect = document.querySelector('#modalidad_id');
    const contenedorOpciones = document.querySelector('#contenedor-opciones');
    const opcionesPostInput = document.querySelector('#opciones_seleccionadas_post');

    if (!paqueteSelect || !modalidadSelect || !contenedorOpciones) return;

    const paqueteCards = document.querySelectorAll('[data-paquete-card]');
    const modalidadCards = document.querySelectorAll('[data-modalidad-card]');

    const infoPaquete = document.querySelector('#info-paquete');
    const paqueteNombreTexto = document.querySelector('#paquete_nombre_texto');
    const paquetePrecioTexto = document.querySelector('#paquete_precio_texto');
    const paqueteTiempoTexto = document.querySelector('#paquete_tiempo_texto');
    const paqueteDescripcionTexto = document.querySelector('#paquete_descripcion_texto');
    const paqueteIncluyeTexto = document.querySelector('#paquete_incluye_texto');

    const infoModalidad = document.querySelector('#info-modalidad');
    const modalidadAnticipoTexto = document.querySelector('#modalidad_anticipo_texto');
    const modalidadAjusteTexto = document.querySelector('#modalidad_ajuste_texto');
    const modalidadTiempoTexto = document.querySelector('#modalidad_tiempo_texto');

    const resumenPaquete = document.querySelector('#resumen_paquete');
    const resumenOpciones = document.querySelector('#resumen_opciones');
    const resumenModalidad = document.querySelector('#resumen_modalidad');

    const subtotalTexto = document.querySelector('#subtotal_texto');
    const ajusteTexto = document.querySelector('#ajuste_texto');
    const totalTexto = document.querySelector('#total_texto');
    const anticipoTexto = document.querySelector('#anticipo_texto');
    const tiempoEntregaTexto = document.querySelector('#tiempo_entrega_texto');

    const subtotalInput = document.querySelector('#subtotal');
    const ajusteInput = document.querySelector('#ajuste');
    const totalInput = document.querySelector('#total');
    const tiempoEntregaInput = document.querySelector('#tiempo_entrega');

    let precioBase = 0;
    let tiempoBase = '';
    let nombrePaquete = '';
    let descripcionPaquete = '';
    let incluyePaquete = '';
    let opcionesSeleccionadas = [];
    let modalidadActual = null;
    let restaurarOpcionesPost = true;

    const opcionesPost = obtenerOpcionesPost();

    paqueteCards.forEach(card => {
        card.addEventListener('click', () => {
            restaurarOpcionesPost = false;
            paqueteSelect.value = card.dataset.paqueteCard;
            paqueteSelect.dispatchEvent(new Event('change'));
        });
    });

    modalidadCards.forEach(card => {
        card.addEventListener('click', () => {
            modalidadSelect.value = card.dataset.modalidadCard;
            modalidadSelect.dispatchEvent(new Event('change'));
        });
    });

    paqueteSelect.addEventListener('change', async function () {
        const opcionSeleccionada = this.options[this.selectedIndex];
        const paqueteId = this.value;

        limpiarSeleccionPaquetes();
        resetearOpciones();
        opcionesSeleccionadas = [];

        if (!paqueteId) {
            precioBase = 0;
            tiempoBase = '';
            nombrePaquete = '';
            descripcionPaquete = '';
            incluyePaquete = '';

            if (infoPaquete) infoPaquete.hidden = true;
            setTexto(resumenPaquete, 'No seleccionado');
            setTexto(paqueteNombreTexto, 'No seleccionado');
            setTexto(paquetePrecioTexto, '0.00');
            setTexto(paqueteTiempoTexto, 'Por definir');
            setTexto(paqueteDescripcionTexto, '');
            setTexto(paqueteIncluyeTexto, '');

            recalcularResumen();
            return;
        }

        const cardActiva = document.querySelector(`[data-paquete-card="${paqueteId}"]`);
        if (cardActiva) {
            cardActiva.classList.add('cotizador-carrito__paquete--activo');
            const accion = cardActiva.querySelector('.cotizador-carrito__accion');
            if (accion) accion.textContent = 'Agregado al carrito';
        }

        precioBase = parseFloat(opcionSeleccionada.dataset.precio) || 0;
        tiempoBase = opcionSeleccionada.dataset.tiempo || '';
        nombrePaquete = opcionSeleccionada.dataset.nombre || '';
        descripcionPaquete = opcionSeleccionada.dataset.descripcion || '';
        incluyePaquete = opcionSeleccionada.dataset.incluye || '';

        setTexto(paqueteNombreTexto, nombrePaquete);
        setTexto(paquetePrecioTexto, formatearNumero(precioBase));
        setTexto(paqueteTiempoTexto, formatearTiempo(tiempoBase));
        setTexto(paqueteDescripcionTexto, descripcionPaquete || 'Sin descripción registrada.');
        setTexto(paqueteIncluyeTexto, incluyePaquete || 'Sin información registrada.');

        if (infoPaquete) infoPaquete.hidden = false;

        setTexto(resumenPaquete, `${nombrePaquete} - $${formatearNumero(precioBase)}`);

        await cargarOpciones(paqueteId, restaurarOpcionesPost);
        restaurarOpcionesPost = false;

        recalcularResumen();
    });

    modalidadSelect.addEventListener('change', function () {
        const opcionSeleccionada = this.options[this.selectedIndex];

        limpiarSeleccionModalidades();

        if (!this.value) {
            modalidadActual = null;
            if (infoModalidad) infoModalidad.hidden = true;
            setTexto(resumenModalidad, 'No seleccionada');
            recalcularResumen();
            return;
        }

        const cardActiva = document.querySelector(`[data-modalidad-card="${this.value}"]`);
        if (cardActiva) {
            cardActiva.classList.add('cotizador-carrito__modalidad--activo');
            const accion = cardActiva.querySelector('.cotizador-carrito__accion');
            if (accion) accion.textContent = 'Modalidad seleccionada';
        }

        modalidadActual = {
            id: this.value,
            nombre: opcionSeleccionada.dataset.nombre || '',
            anticipo: parseFloat(opcionSeleccionada.dataset.anticipo) || 0,
            tipoAjuste: opcionSeleccionada.dataset.tipoAjuste || 'ninguno',
            valorAjuste: parseFloat(opcionSeleccionada.dataset.valorAjuste) || 0,
            tiempoEntrega: opcionSeleccionada.dataset.tiempoEntrega || '',
            prioridad: opcionSeleccionada.dataset.prioridad || ''
        };

        setTexto(modalidadAnticipoTexto, modalidadActual.anticipo);

        let textoAjuste = 'Sin ajuste';

        if (modalidadActual.tipoAjuste === 'descuento') {
            textoAjuste = `Descuento de ${modalidadActual.valorAjuste}%`;
        } else if (modalidadActual.tipoAjuste === 'recargo') {
            textoAjuste = `Recargo de ${modalidadActual.valorAjuste}%`;
        }

        setTexto(modalidadAjusteTexto, textoAjuste);
        setTexto(modalidadTiempoTexto, formatearTiempo(modalidadActual.tiempoEntrega));

        if (infoModalidad) infoModalidad.hidden = false;

        setTexto(resumenModalidad, modalidadActual.nombre);
        recalcularResumen();
    });

    async function cargarOpciones(paqueteId, debeRestaurar = false) {
        contenedorOpciones.innerHTML = `
            <div class="cotizador-carrito__estado-vacio">
                Cargando funciones disponibles...
            </div>
        `;

        const datos = new FormData();
        datos.append('paquete_id', paqueteId);

        try {
            const respuesta = await fetch('/cotizador/opciones', {
                method: 'POST',
                body: datos
            });

            const opciones = await respuesta.json();

            if (!Array.isArray(opciones) || opciones.length === 0) {
                contenedorOpciones.innerHTML = `
                    <div class="cotizador-carrito__estado-vacio">
                        Este paquete no tiene opciones adicionales disponibles por ahora.
                    </div>
                `;
                return;
            }

            contenedorOpciones.innerHTML = '';

            opciones.forEach(opcion => {
                const precio = parseFloat(opcion.precio || 0);
                const id = `opcion_${opcion.id}`;
                const opcionIdString = String(opcion.id);
                const checked = debeRestaurar && opcionesPost.includes(opcionIdString) ? 'checked' : '';

                const item = document.createElement('label');
                item.classList.add('cotizador-carrito__opcion');
                item.setAttribute('for', id);

                item.innerHTML = `
                    <input
                        type="checkbox"
                        name="opciones[]"
                        id="${id}"
                        value="${escapeHtml(opcion.id)}"
                        data-nombre="${escapeHtml(opcion.nombre || '')}"
                        data-precio="${precio}"
                        ${checked}
                    >

                    <span class="cotizador-carrito__opcion-control"></span>

                    <span class="cotizador-carrito__opcion-contenido">
                        <strong>${escapeHtml(opcion.nombre || 'Opción sin nombre')}</strong>
                        ${opcion.descripcion ? `<small>${escapeHtml(opcion.descripcion)}</small>` : ''}
                    </span>

                    <span class="cotizador-carrito__opcion-precio">
                        + $${formatearNumero(precio)}
                    </span>
                `;

                const input = item.querySelector('input');
                input.addEventListener('change', manejarCambioOpciones);

                contenedorOpciones.appendChild(item);
            });

            manejarCambioOpciones();

        } catch (error) {
            contenedorOpciones.innerHTML = `
                <div class="cotizador-carrito__estado-vacio cotizador-carrito__estado-vacio--error">
                    Hubo un error al cargar las opciones del paquete.
                </div>
            `;
        }
    }

    function manejarCambioOpciones() {
        const checkboxes = document.querySelectorAll('#contenedor-opciones input[type="checkbox"]:checked');

        opcionesSeleccionadas = Array.from(checkboxes).map(checkbox => ({
            id: checkbox.value,
            nombre: checkbox.dataset.nombre || '',
            precio: parseFloat(checkbox.dataset.precio) || 0
        }));

        recalcularResumen();
    }

    function recalcularResumen() {
        const totalOpciones = opcionesSeleccionadas.reduce((acc, opcion) => acc + opcion.precio, 0);
        const subtotal = precioBase + totalOpciones;

        let ajuste = 0;
        let total = subtotal;

        if (modalidadActual) {
            if (modalidadActual.tipoAjuste === 'descuento') {
                ajuste = (subtotal * modalidadActual.valorAjuste) / 100;
                total = subtotal - ajuste;
            } else if (modalidadActual.tipoAjuste === 'recargo') {
                ajuste = (subtotal * modalidadActual.valorAjuste) / 100;
                total = subtotal + ajuste;
            }
        }

        const porcentajeAnticipo = modalidadActual?.anticipo || 0;
        const anticipo = (total * porcentajeAnticipo) / 100;

        pintarOpcionesResumen();

        setTexto(subtotalTexto, `$${formatearNumero(subtotal)}`);
        setTexto(totalTexto, `$${formatearNumero(total)}`);
        setTexto(anticipoTexto, `$${formatearNumero(anticipo)}`);

        if (modalidadActual?.tipoAjuste === 'descuento') {
            setTexto(ajusteTexto, `-$${formatearNumero(ajuste)}`);
        } else if (modalidadActual?.tipoAjuste === 'recargo') {
            setTexto(ajusteTexto, `+$${formatearNumero(ajuste)}`);
        } else {
            setTexto(ajusteTexto, '$0.00');
        }

        const tiempoFinal = modalidadActual?.tiempoEntrega || tiempoBase || 'Por definir';
        setTexto(tiempoEntregaTexto, formatearTiempo(tiempoFinal));

        if (subtotalInput) subtotalInput.value = subtotal.toFixed(2);
        if (ajusteInput) ajusteInput.value = ajuste.toFixed(2);
        if (totalInput) totalInput.value = total.toFixed(2);
        if (tiempoEntregaInput) tiempoEntregaInput.value = tiempoFinal;
    }

    function pintarOpcionesResumen() {
        if (!resumenOpciones) return;

        if (!opcionesSeleccionadas.length) {
            resumenOpciones.innerHTML = '<li>Sin opciones seleccionadas</li>';
            return;
        }

        resumenOpciones.innerHTML = '';

        opcionesSeleccionadas.forEach(opcion => {
            const li = document.createElement('li');
            li.innerHTML = `
                <span>${escapeHtml(opcion.nombre)}</span>
                <strong>+$${formatearNumero(opcion.precio)}</strong>
            `;
            resumenOpciones.appendChild(li);
        });
    }

    function resetearOpciones() {
        contenedorOpciones.innerHTML = `
            <div class="cotizador-carrito__estado-vacio">
                Primero selecciona un paquete para ver las opciones disponibles.
            </div>
        `;

        opcionesSeleccionadas = [];
        pintarOpcionesResumen();
    }

    function limpiarSeleccionPaquetes() {
        paqueteCards.forEach(card => {
            card.classList.remove('cotizador-carrito__paquete--activo');

            const accion = card.querySelector('.cotizador-carrito__accion');
            if (accion) accion.textContent = 'Agregar al carrito';
        });
    }

    function limpiarSeleccionModalidades() {
        modalidadCards.forEach(card => {
            card.classList.remove('cotizador-carrito__modalidad--activo');

            const accion = card.querySelector('.cotizador-carrito__accion');
            if (accion) accion.textContent = 'Elegir modalidad';
        });
    }

    function obtenerOpcionesPost() {
        if (!opcionesPostInput || !opcionesPostInput.value) {
            return [];
        }

        try {
            const opciones = JSON.parse(opcionesPostInput.value);

            if (!Array.isArray(opciones)) {
                return [];
            }

            return opciones.map(opcion => String(opcion));
        } catch (error) {
            return [];
        }
    }

    function formatearTiempo(tiempo) {
        const valor = String(tiempo || '').trim();

        if (!valor) {
            return 'Por definir';
        }

        if (/^\d+(\.\d+)?$/.test(valor)) {
            return `${valor} días hábiles`;
        }

        return valor;
    }

    function setTexto(elemento, texto) {
        if (!elemento) return;

        if ('value' in elemento) {
            elemento.value = texto;
        } else {
            elemento.textContent = texto;
        }
    }

    function formatearNumero(numero) {
        return Number(numero || 0).toLocaleString('es-CO', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
    }

    function escapeHtml(texto) {
        const div = document.createElement('div');
        div.textContent = texto;
        return div.innerHTML;
    }

    if (paqueteSelect.value) {
        paqueteSelect.dispatchEvent(new Event('change'));
    }

    if (modalidadSelect.value) {
        modalidadSelect.dispatchEvent(new Event('change'));
    } else {
        recalcularResumen();
    }
};

document.addEventListener('DOMContentLoaded', iniciarCotizador);